import * as React from 'react';

import { useInterval } from '../hooks';
import { formatAsDateTime, formatAsReadableDate } from '../util';

type Props = {
  timestamp: string;
};

export default function DateWithTooltip({ timestamp }: Props) {
  const [, setInvalidateToken] = React.useState(0);
  useInterval(() => {
    setInvalidateToken(Math.random());
  }, 1000 * 10);

  return (
    <span title={formatAsDateTime(timestamp)} style={{ cursor: 'default' }}>
      {formatAsReadableDate(timestamp)}
    </span>
  );
}
